/**
 * 隐私设置页懒加载壳（14.30；MyProfileLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function MyPrivacyLazy() {
  const { mod } = useLazyModule(() => import('./MyPrivacyPage'));
  if (mod === null) return <div data-testid="my-privacy-loading-shell">加载中…</div>;
  return <mod.MyPrivacyPage />;
}
